module.exports = __webpack_public_path__ + "media/images/cosmos-bbd49be6f2828a8006889cfa506da45b.svg";